import { FilterUserEnum, validityStatusEnum } from '@helpers/enums';
import { IFilterGroupsCategories } from './iFilterGroupsCategories';
import { IRangeDate } from './iRangeDate';

interface IParameters {
  users_id: (number | null)[];
  groups_categories_id: IFilterGroupsCategories[];
  range_date: IRangeDate | null;
  filterUserEnum: FilterUserEnum;
  batches_id: (number | null)[];
  validity: validityStatusEnum;
}
export interface IProgressFilters {
  parameters: IParameters;
}

class ProgressFiltersClass implements IProgressFilters {
  parameters: IParameters;

  constructor(parameters: IParameters) {
    this.parameters = parameters;
  }
}

export default ProgressFiltersClass;
